// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.nemuUserContainer {
    position: absolute;
    max-width: 280px;
    width: 100vw;
    height: 100vh;
}

.headMenuUser{
    /* position: absolute; */
    background: #007399;
    width: 100%;
    height:85px;
    overflow: hidden;
}
.headTitle{
    /* background: #007399; */
    width: 100%;
    padding: 0;
}
.headMenuUser p {
    width: 100%;
    color: white;
    font-size: 24px;
    size: 24px;
    padding-left: 10px;
}
.xclose{
    color:white;
    float: right;
    font-size: 35px;
    padding-right: 10px;
}
.mdclose{
    color:black;
    float: right;
    font-size: 35px;
    padding-right: 10px;
}
.menuAllcategory{
    /* height: 100%; */
    width: 100%;
    background-color: white;
    color: black;
    /* box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.5); */
    border: 1px solid #e2dfdf;
    position: fixed;
    /* top: 85px; */
    /* left: 0; */
    padding: 0;
    margin: 0;
    max-width: 280px;
    z-index: 200;
    transform: translate(-100%);
    transition: transform 0.6s ease-out ;
    overflow: auto
}
.menuAllcategory.open{
   transform: translatex(0);
}
.menuAdminClass{
     height: 100%;
     width: 100%;
     background-color: white;
     color: black;
     /* box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.5); */
     border: 1px solid #e2dfdf;
     position: fixed;
     top: 85px;
     /* left: 0; */
     padding: 0;
     margin: 0;
     max-width: 280px;
     z-index: 200;
     transform: translate(-100%);
     transition: transform 0.6s ease-out ;
     overflow: auto
}
.menuAdminClass.open {
    transform: translatex(0);
}

.menuUserClass {
    height: 100%;
    width: 100%;
    color: black;
    background-color: white;
    /* box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.5); */
    border: 1px solid #e2dfdf;
    top: 85px;
    /* left: 0; */
    padding: 0;
    margin: 0;
    max-width: 280px;
    z-index: 400;
    transform: translate(-100%);
    transition: transform 0.6s ease-out ;
    overflow: auto ;
    /* position: fixed */
}
.menuUserClass.open{
    transform: translatex(0);
}

.menuUserClass ul, .menuAdminClass ul, .menuAllcategory ul{
    width: 100%;
    list-style-type: none;
    margin: 0;
    padding: 0;
    /* border-bottom: 1px solid #f1f1f1; */
}
.menuUserClass li, .menuAdminClass li, .menuAllcategory li{
    padding-left: 10px;
  border-bottom: 1px solid rgb(232, 248, 250);
}
.menuUserClass li:last-child, .menuAdminClass li:last-child, .menuAllcategor li:last-child{
    border-bottom: none;
}
.menuUserClass li a.active, .menuAdminClass li a.active, .menuAllcategory li a.active {
    background-color: #4CAF50;
    color: black;
  }
  
.menuUserClass li:hover:not(.active), .menuAdminClass li:hover:not(.active), .menuAllcategory li:hover:not(.active) {
    /* margin: 0; */
    background-color:rgba(0,115,153,0.4);

    color: black;
  }
`, "",{"version":3,"sources":["webpack://./src/includes/menu/menu.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,gDAAgD;IAChD,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,aAAa;IACb,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,oCAAoC;IACpC;AACJ;AACA;GACG,wBAAwB;AAC3B;AACA;KACK,YAAY;KACZ,WAAW;KACX,uBAAuB;KACvB,YAAY;KACZ,gDAAgD;KAChD,yBAAyB;KACzB,eAAe;KACf,SAAS;KACT,aAAa;KACb,UAAU;KACV,SAAS;KACT,gBAAgB;KAChB,YAAY;KACZ,2BAA2B;KAC3B,oCAAoC;KACpC;AACL;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gDAAgD;IAChD,yBAAyB;IACzB,SAAS;IACT,aAAa;IACb,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,oCAAoC;IACpC,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,sCAAsC;AAC1C;AACA;IACI,kBAAkB;EACpB,2CAA2C;AAC7C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,YAAY;EACd;;AAEF;IACI,eAAe;IACf,oCAAoC;;IAEpC,YAAY;EACd","sourcesContent":["\n.nemuUserContainer {\n    position: absolute;\n    max-width: 280px;\n    width: 100vw;\n    height: 100vh;\n}\n\n.headMenuUser{\n    /* position: absolute; */\n    background: #007399;\n    width: 100%;\n    height:85px;\n    overflow: hidden;\n}\n.headTitle{\n    /* background: #007399; */\n    width: 100%;\n    padding: 0;\n}\n.headMenuUser p {\n    width: 100%;\n    color: white;\n    font-size: 24px;\n    size: 24px;\n    padding-left: 10px;\n}\n.xclose{\n    color:white;\n    float: right;\n    font-size: 35px;\n    padding-right: 10px;\n}\n.mdclose{\n    color:black;\n    float: right;\n    font-size: 35px;\n    padding-right: 10px;\n}\n.menuAllcategory{\n    /* height: 100%; */\n    width: 100%;\n    background-color: white;\n    color: black;\n    /* box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.5); */\n    border: 1px solid #e2dfdf;\n    position: fixed;\n    /* top: 85px; */\n    /* left: 0; */\n    padding: 0;\n    margin: 0;\n    max-width: 280px;\n    z-index: 200;\n    transform: translate(-100%);\n    transition: transform 0.6s ease-out ;\n    overflow: auto\n}\n.menuAllcategory.open{\n   transform: translatex(0);\n}\n.menuAdminClass{\n     height: 100%;\n     width: 100%;\n     background-color: white;\n     color: black;\n     /* box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.5); */\n     border: 1px solid #e2dfdf;\n     position: fixed;\n     top: 85px;\n     /* left: 0; */\n     padding: 0;\n     margin: 0;\n     max-width: 280px;\n     z-index: 200;\n     transform: translate(-100%);\n     transition: transform 0.6s ease-out ;\n     overflow: auto\n}\n.menuAdminClass.open {\n    transform: translatex(0);\n}\n\n.menuUserClass {\n    height: 100%;\n    width: 100%;\n    color: black;\n    background-color: white;\n    /* box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.5); */\n    border: 1px solid #e2dfdf;\n    top: 85px;\n    /* left: 0; */\n    padding: 0;\n    margin: 0;\n    max-width: 280px;\n    z-index: 400;\n    transform: translate(-100%);\n    transition: transform 0.6s ease-out ;\n    overflow: auto ;\n    /* position: fixed */\n}\n.menuUserClass.open{\n    transform: translatex(0);\n}\n\n.menuUserClass ul, .menuAdminClass ul, .menuAllcategory ul{\n    width: 100%;\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    /* border-bottom: 1px solid #f1f1f1; */\n}\n.menuUserClass li, .menuAdminClass li, .menuAllcategory li{\n    padding-left: 10px;\n  border-bottom: 1px solid rgb(232, 248, 250);\n}\n.menuUserClass li:last-child, .menuAdminClass li:last-child, .menuAllcategor li:last-child{\n    border-bottom: none;\n}\n.menuUserClass li a.active, .menuAdminClass li a.active, .menuAllcategory li a.active {\n    background-color: #4CAF50;\n    color: black;\n  }\n  \n.menuUserClass li:hover:not(.active), .menuAdminClass li:hover:not(.active), .menuAllcategory li:hover:not(.active) {\n    /* margin: 0; */\n    background-color:rgba(0,115,153,0.4);\n\n    color: black;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
